import { render } from "./ValuesSection.vue?vue&type=template&id=2cc609c4"
import script from "./ValuesSection.vue?vue&type=script&lang=js"
export * from "./ValuesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__